/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowNarrowUp = createReactComponent("arrow-narrow-up", "IconArrowNarrowUp", [
  ["path", { d: "M12 5l0 14", key: "svg-0" }],
  ["path", { d: "M16 9l-4 -4", key: "svg-1" }],
  ["path", { d: "M8 9l4 -4", key: "svg-2" }]
]);

export { IconArrowNarrowUp as default };
//# sourceMappingURL=IconArrowNarrowUp.js.map
